export default __webpack_public_path__ + "src/shared/svg/providers/9754a5819ad608c84c85bf902f7e6b28.png";